/* THERO Creator videos - silent previews, the full-screen player and measurement for sections/thero-creator-videos.liquid
   (2026-09-24). Loaded (defer) only by pages that render at least one video card; guarded so two sections on one page
   run it once. No dependencies.

   Bytes and motion (the performance budget is a MUST): NOTHING downloads until a preview plays or the player opens.
   - Phones / touch: the card mostly in view plays its first PREVIEW_S seconds ONCE (the stream's 480p variant, ~1.2
     Mbps), then rests on its cover. WCAG 2.2.2 - moving content longer than 5 s needs a pause control - so a
     preview stays under 5 s.
   - Computers (a real hover pointer): a card previews while the pointer is on it (the 720p variant; the MP4 where
     the browser has no native HLS).
   - Never for prefers-reduced-motion, Data Saver, a 2g/3g connection, or when the section switches previews off.
   - A refused play() (Low Power Mode, Instagram's in-app browser) is caught: the cover simply stays.
   The player starts the video WITH sound inside the tap (browsers allow sound only then); if the browser refuses, it
   plays muted and the sound button says "Tap for sound". HLS (adaptive) where the browser plays it natively (Safari,
   Android, desktop Chrome 142+), else the 720p MP4 (1080p on computers).
   Measurement (2026-09-30): the 'thero:track' channel -> assets/thero-analytics.js -> GA4: creator_video_play
   {video_id, video_creator, video_product, video_position, play_trigger}, creator_video_progress {... video_percent},
   creator_video_instagram_click {... link_location}; user labels video_viewer / last_video; the card's slot is set
   at init (data-track-slot) and the player tells its add-to-cart form which video is showing (data-track-source-id). */
(function () {
  if (window.__theroCV) return;
  window.__theroCV = true;

  var PREVIEW_S = 4.5;
  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  var REDUCE = mq('(prefers-reduced-motion: reduce)');
  var HOVER = mq('(hover: hover) and (pointer: fine)');
  var conn = navigator.connection || {};
  var LIGHT = !!conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '');
  var probe = document.createElement('video');
  var HLS = !!(probe.canPlayType && probe.canPlayType('application/vnd.apple.mpegurl'));

  /* Measurement (2026-09-30): announce on the site's ONE tracking channel; assets/thero-analytics.js sends it to
     Google Analytics (page type added there). The old window.dataLayer push reached no tag - 0 video events in GA4
     over 28 days. The card that opens the player is also counted by the tracker as select_promotion (its
     data-track-promo label); these events add what only this file knows: which video played, how, how far. */
  function track(ev, card, params, user) {
    var p = {
      video_id: card ? card.getAttribute('data-tcv-video') || '' : '',
      video_creator: card ? card.getAttribute('data-tcv-creator') || '' : '',
      video_product: card ? card.getAttribute('data-tcv-product') || '' : ''
    };
    if (params) for (var k in params) p[k] = params[k];
    document.dispatchEvent(new CustomEvent('thero:track', { detail: { event: ev, params: p, user: user || null } }));
  }
  function creatorSlug(card) {
    var c = card ? card.getAttribute('data-tcv-creator') || '' : '';
    return c.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 36);
  }
  function quiet(p) { if (p && p.catch) p.catch(function () {}); }

  /* ---------- which file a preview plays ----------
     Liquid only exposes Shopify's 1080p MP4 (4.8 Mbps) and the HLS stream for a store-entry video (measured
     2026-09-24: video.sources = [m3u8, mp4 606x1080]), and the stream's master playlist lists 1080p FIRST - the
     variant Safari starts on. So a preview reads the master playlist (a few hundred bytes, same origin) and plays ONE
     variant's own playlist: the tallest at or under 480 on phones, 720 on computers. No file names are guessed - the
     playlist format is the standard. Without native HLS: computers fall back to the MP4, phones show the cover only. */
  var variantCache = {};
  function variantFor(master, maxH) {
    var key = master + '|' + maxH;
    if (!variantCache[key]) {
      var base = new URL(master, location.href).href;
      variantCache[key] = fetch(base, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('playlist ' + r.status); return r.text(); })
        .then(function (txt) {
          var lines = txt.split(/\r?\n/), list = [];
          for (var i = 0; i < lines.length - 1; i++) {
            var m = /^#EXT-X-STREAM-INF:(.*)$/.exec(lines[i]);
            var uri = (lines[i + 1] || '').trim();
            if (!m || !uri || uri.charAt(0) === '#') continue;
            var bw = /(?:^|,)BANDWIDTH=(\d+)/.exec(m[1]), res = /RESOLUTION=(\d+)x(\d+)/.exec(m[1]);
            list.push({ uri: new URL(uri, base).href, bw: bw ? +bw[1] : 0, h: res ? +res[2] : 0 });
          }
          if (!list.length) return base;   // already a single-variant playlist
          list.sort(function (a, b) { return a.bw - b.bw; });
          var pick = list[0];
          list.forEach(function (v) { if (v.h && v.h <= maxH && v.bw >= pick.bw) pick = v; });
          return pick.uri;
        })
        .catch(function () { return ''; });
    }
    return variantCache[key];
  }
  function previewSource(card) {
    var hls = card.getAttribute('data-tcv-src-hls');
    if (HLS && hls) return variantFor(hls, HOVER ? 720 : 480);
    // no native HLS: only a computer (desktop bandwidth, hover = the shopper asked) takes the MP4
    return Promise.resolve(HOVER ? (card.getAttribute('data-tcv-src-m') || card.getAttribute('data-tcv-src-l') || '') : '');
  }

  /* ---------- silent previews ---------- */
  function previewVideo(card) { return card.querySelector('.tcv-preview'); }
  function startPreview(card, loop) {
    var v = previewVideo(card);
    if (!v || card.classList.contains('is-previewing')) return;
    card.__tcvWant = true;
    var go = function () {
      if (!card.__tcvWant || !v.getAttribute('src')) return;   // the shopper moved on while the playlist loaded
      v.muted = true;
      v.loop = !!loop;
      try { v.currentTime = 0; } catch (e) {}
      quiet(v.play());
    };
    if (v.getAttribute('src')) { go(); return; }
    previewSource(card).then(function (src) {
      if (!src) return;
      if (!v.getAttribute('src')) v.setAttribute('src', src);
      go();
    });
  }
  function stopPreview(card) {
    var v = previewVideo(card);
    card.__tcvWant = false;
    card.classList.remove('is-previewing');
    if (v && !v.paused) v.pause();
  }
  function wirePreview(card) {
    var v = previewVideo(card);
    if (!v) return;
    v.addEventListener('playing', function () { card.classList.add('is-previewing'); });
    v.addEventListener('timeupdate', function () {
      // phones: one short look, then the sharp cover again (and no more bytes)
      if (!v.loop && v.currentTime >= PREVIEW_S) { card.__tcvDone = true; stopPreview(card); }
    });
    v.addEventListener('ended', function () { card.__tcvDone = true; stopPreview(card); });
  }

  function initPreviews(root, cards) {
    if (REDUCE || LIGHT || root.getAttribute('data-tcv-previews') !== 'on') return;
    cards.forEach(wirePreview);
    if (HOVER) {
      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () { startPreview(card, true); });
        card.addEventListener('mouseleave', function () { stopPreview(card); });
      });
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    var ratios = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
      if (root.__tcvPlayerOpen) return;
      var best = null, bestR = 0.6;
      ratios.forEach(function (r, card) { if (r >= bestR && !card.__tcvDone) { best = card; bestR = r; } });
      cards.forEach(function (card) { if (card !== best) stopPreview(card); });
      if (best) startPreview(best, false);
    }, { threshold: [0, 0.3, 0.6, 0.8, 1] });
    cards.forEach(function (card) { io.observe(card); });
    root.__tcvIO = io;
  }

  /* ---------- the row: dots on phones, arrows on computers ---------- */
  function initRow(root) {
    var track = root.querySelector('[data-tcv-track]');
    if (!track) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.tcv-dot'));
    var prev = root.querySelector('[data-tcv-prev]');
    var next = root.querySelector('[data-tcv-next]');
    var gap = 0;
    function measureGap() { gap = parseFloat(getComputedStyle(track).columnGap) || 0; }
    function step() {
      var c = track.querySelector('[data-tcv-card]');
      return c ? c.getBoundingClientRect().width + gap : track.clientWidth;
    }
    var queued = false;
    function sync() {
      queued = false;
      var max = track.scrollWidth - track.clientWidth;
      var over = max > 2;
      root.toggleAttribute('data-tcv-over', over);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (dots.length) {
        var i = Math.min(dots.length - 1, Math.round(track.scrollLeft / Math.max(1, step())));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }
    }
    function later() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
    track.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', function () { measureGap(); later(); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    measureGap();
    sync();
  }

  /* ---------- the player ---------- */
  function initPlayer(root, cards) {
    var dlg = root.querySelector('[data-tcv-viewer]');
    if (!dlg || !cards.length) return;
    var v = dlg.querySelector('.tcv-v-video');
    var slot = dlg.querySelector('[data-tcv-panel-slot]');
    var bar = dlg.querySelector('[data-tcv-progress]');
    var toggleBtn = dlg.querySelector('[data-tcv-toggle]');
    var muteBtn = dlg.querySelector('[data-tcv-mute]');
    var live = dlg.querySelector('[data-tcv-live]');
    var vprev = dlg.querySelector('[data-tcv-vprev]');
    var vnext = dlg.querySelector('[data-tcv-vnext]');
    var idx = 0;
    if (cards.length < 2) { vprev.hidden = true; vnext.hidden = true; }

    function srcFor(card) {
      var hls = card.getAttribute('data-tcv-src-hls');
      if (HLS && hls) return hls;
      var wide = window.innerWidth >= 990;
      return (wide ? card.getAttribute('data-tcv-src-l') : '') || card.getAttribute('data-tcv-src-m') ||
             card.getAttribute('data-tcv-src-s') || '';
    }
    function setMuted(m, auto) {
      v.muted = m;
      dlg.classList.toggle('is-muted', m);
      dlg.classList.toggle('is-muted-auto', m && !!auto);
      muteBtn.setAttribute('aria-pressed', m ? 'true' : 'false');
      muteBtn.setAttribute('aria-label', m ? 'Turn the sound on' : 'Mute');
    }
    function play() {
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          // sound refused (in-app browser / Low Power Mode): play muted and offer the sound
          setMuted(true, true);
          quiet(v.play());
        });
      }
    }
    var marks = {};   // watch quartiles already reported for the video showing now
    function load(i, trigger) {
      idx = (i + cards.length) % cards.length;
      var card = cards[idx];
      root.__tcvShown = card;   // the player's panel links report against the video that is showing
      marks = {};
      // the add-to-cart form inside the player reports against the video that is showing (thero-analytics.js)
      dlg.setAttribute('data-track-source-id', card.getAttribute('data-tcv-video') || '');
      dlg.setAttribute('data-track-source-pos', String(idx + 1));
      var cover = card.querySelector('.tcv-cover');
      v.setAttribute('poster', cover ? (cover.currentSrc || cover.src) : '');
      v.setAttribute('src', srcFor(card));
      bar.style.width = '0%';
      var tpl = card.querySelector('template[data-tcv-panel]');
      slot.replaceChildren(tpl ? tpl.content.cloneNode(true) : document.createTextNode(''));
      // the panel's quantity selector was drawn at page load - bring it to the cart as it is now (assets/thero-cart.js)
      if (window.theroQtySync) window.theroQtySync(slot);
      live.textContent = 'Video ' + (idx + 1) + ' of ' + cards.length + ': ' + (card.getAttribute('data-tcv-creator') || '');
      track('creator_video_play', card, { video_position: idx + 1, play_trigger: trigger || 'open' },
        { video_viewer: 'yes', last_video: creatorSlug(card) });
    }
    // 25 / 50 / 75 / 100 % of the video showing now, each once per load (a seek forward reports every mark it skips)
    function progress() {
      if (!v.duration) return;
      var pct = (v.currentTime / v.duration) * 100;
      [25, 50, 75, 100].forEach(function (m) {
        if (!marks[m] && (pct >= m || (m === 100 && pct >= 99))) {
          marks[m] = true;
          track('creator_video_progress', cards[idx], { video_position: idx + 1, video_percent: m });
        }
      });
    }
    function open(i) {
      root.__tcvPlayerOpen = true;
      cards.forEach(stopPreview);
      load(i, 'open');
      setMuted(false, false);
      if (!dlg.open) dlg.showModal();
      document.documentElement.classList.add('tcv-lock');
      play();   // inside the tap: the only moment browsers allow sound
    }
    function close() {
      v.pause();
      v.removeAttribute('src');
      v.load();   // drop the buffered video - no more bytes after the player closes
      if (dlg.open) dlg.close();
      document.documentElement.classList.remove('tcv-lock');
      dlg.classList.remove('is-paused', 'is-waiting');
      root.__tcvPlayerOpen = false;
    }
    function go(d, trigger) { load(idx + d, trigger); play(); }

    cards.forEach(function (card, i) {
      var btn = card.querySelector('[data-tcv-open]');
      if (btn) btn.addEventListener('click', function () { open(i); });
    });
    toggleBtn.addEventListener('click', function () { if (v.paused) { play(); } else { v.pause(); } });
    muteBtn.addEventListener('click', function () { setMuted(!v.muted, false); if (v.paused) play(); });
    vprev.addEventListener('click', function () { go(-1, 'prev'); });
    vnext.addEventListener('click', function () { go(1, 'next'); });
    dlg.querySelector('[data-tcv-close]').addEventListener('click', close);
    // Esc: run our own clean-up (pause, drop the video) instead of the browser's bare close
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    // a tap on the dark area around the player closes it (closedby="any" is not in Safari yet)
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1, 'key'); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1, 'key'); }
      else if (e.key === 'm' || e.key === 'M') { setMuted(!v.muted, false); }
    });
    // Add to cart inside the player: this closes the player; assets/thero-cart.js (a document CAPTURE listener, so it
    // runs just before this one since 2026-09-30) has already started the add, and opens the cart drawer when it lands -
    // the site's one add-to-cart behaviour.
    dlg.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && /\/cart\/add/.test(f.action)) close();
    });
    v.addEventListener('play', function () { dlg.classList.remove('is-paused'); toggleBtn.setAttribute('aria-label', 'Pause'); });
    v.addEventListener('pause', function () { dlg.classList.add('is-paused'); toggleBtn.setAttribute('aria-label', 'Play'); });
    v.addEventListener('waiting', function () { dlg.classList.add('is-waiting'); });
    v.addEventListener('playing', function () { dlg.classList.remove('is-waiting'); });
    v.addEventListener('timeupdate', function () {
      if (v.duration) bar.style.width = Math.min(100, (v.currentTime / v.duration) * 100).toFixed(2) + '%';
      progress();
    });
    v.addEventListener('ended', function () { if (!marks[100]) { marks[100] = true; track('creator_video_progress', cards[idx], { video_position: idx + 1, video_percent: 100 }); } });
    // a horizontal swipe on the video = next / previous (phones)
    var sx = 0, sy = 0, st = 0;
    var stage = dlg.querySelector('.tcv-v-stage');
    stage.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; st = Date.now();
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (cards.length < 2) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && Date.now() - st < 800) {
        e.preventDefault();   // not a tap: do not also toggle play
        go(dx < 0 ? 1 : -1, 'swipe');
      }
    });
    root.__tcvClose = close;
  }

  /* ---------- measurement: Instagram links on the cards and in the player ---------- */
  function initLinks(root) {
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-tcv-ig]');
      if (!a) return;
      // on a card: that card; in the player: the video that is showing
      var card = a.closest('[data-tcv-card]') || root.__tcvShown || null;
      track('creator_video_instagram_click', card, { link_location: a.getAttribute('data-tcv-ig') || '' });
    });
  }

  function init(root) {
    if (!root || root.__tcvInit) return;
    root.__tcvInit = true;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tcv-card]'));
    // Measurement: the card order comes from a server-side sort (followers), so the position is known only here;
    // thero-analytics.js reads data-track-slot when the card is seen or tapped.
    var place = root.getAttribute('data-tcv-context') === 'home' ? 'home' : 'pdp';
    cards.forEach(function (c, i) { c.setAttribute('data-track-slot', place + '_creator_videos:' + (i + 1)); });
    initRow(root);
    initPreviews(root, cards);
    initPlayer(root, cards);
    initLinks(root);
  }
  function initAll() { document.querySelectorAll('[data-tcv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // theme editor
  document.addEventListener('shopify:section:load', function (e) { if (e.target) e.target.querySelectorAll('[data-tcv]').forEach(init); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-tcv]').forEach(function (root) {
      if (root.__tcvClose) root.__tcvClose();
      if (root.__tcvIO) root.__tcvIO.disconnect();
    });
  });
  // theme editor: clicking a "Creator video" block in the list scrolls the row sideways to its card
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-tcv-card]') : null;
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });
})();
